// extracted by mini-css-extract-plugin
export default {"container":"SearchInput_container__bT8+T","icon":"SearchInput_icon__2xix-","input":"SearchInput_input__oXb+b"};